import React from 'react';
import '../CSS/style/style.css';
import soccer from '../resource/soccer.avif'
import tram from '../resource/tram.avif'
import net from '../resource/net.jpeg'
import fire from '../resource/fire.jpg'
import beer from '../resource/beer.avif'
import table from '../resource/table.jpeg'
import camp from '../resource/camp.jpeg'
import menu from '../resource/menu.jpeg'
import shower from '../resource/shower.avif'

const Services = () => {
    return (
        <div className="main-wrapper">
            <section className="foot-banner"></section>

            <div className="service-container">
                <h2>🏡 물조은펜션 제공 서비스</h2>
                <p>자연 속 힐링과 편안한 즐거움을 더해줄 다양한 부대시설을 이용해보세요 😊</p>

                <h2>🍗 먹거리 & 편의시설</h2>
                <img src={menu} alt="Teamtoys Logo"/>
                <p>
                    매점 운영<br/>
                    간단한 생필품과 간식 구입 가능!<br/><br/>

                    치킨 & 백숙등 다양한 먹거리 주문 가능<br/>
                    펜션에서 즐기는 따끈한 한끼!
                </p>

                <img src={beer} alt="Teamtoys Logo"/>
                <p>
                    시원한 생맥주 판매<br/>
                    계곡 옆에서 즐기는 짜릿한 한잔!
                </p>

                <h2>🔥 야외 즐길거리</h2>
                <img src={fire} alt="Teamtoys Logo"/>
                <p>
                    숯불 BBQ장<br/>
                    탁 트인 자연 속에서 바비큐 타임! (숯·그릴 판매, 사전 신청)
                </p>

                <img src={tram} alt="Teamtoys Logo"/>
                <p>
                    트램폴린<br/>
                    아이들이 뛰놀기 좋은 공간 (보호자 동반 후 안전하게 이용해주세요)
                </p>

                <img src={net} alt="Teamtoys Logo"/>
                <p>
                    해먹<br/>
                    바람 솔솔~ 나무 그늘 아래 편안한 휴식
                </p>


                <h2>🏕 캠핑 & 대여 서비스</h2>
                <img src={camp} alt="Teamtoys Logo"/>
                <p>오토캠핑 가능 구역 운영<br/>캠핑카 또는 텐트로 즐기는 1박2일!</p>

                <img src={table} alt="Teamtoys Logo"/>
                <p>평상 대여<br/>계곡 옆 평상에서 여유로운 시간 보내세요</p>


                <h2>🚿 편의 시설</h2>
                <img src={shower} alt="Teamtoys Logo"/>
                <p>야외 샤워실 & 화장실<br/>캠핑 손님 및 바비큐 이용 시 편리하게 사용 가능</p>

                <div className="service-desc">
                    <div className="service-desc2">
                        <h3 style={{marginTop: 0}}>◎ 평상대여료</h3>
                        <span>
                            <b>평일</b><br/>
                            4인 기준 5만원 (추가 시 1인당 10,000원)<br/>

                            <b>주말</b><br/>
                            3인 이하 5만원<br/>
                            4인 기준 6만원 (추가 시 1인당 10,000원)<br/>
                          - 환불 규정은 펜션과 동일합니다.
                        </span>

                        <h3>◎ 평상대여시간</h3>
                        <span>오전 6시 ~ 밤 12시 전까지</span>

                        <h3>◎ 평상이용안내</h3>
                        <span>
                          - 개별 쓰레기 봉투 지참 및 분리수거 필수입니다.<br/>
                          - 이용하신 자리는 꼭 정리 바랍니다.<br/>
                          - 개수대, 화장실, 샤워실 이용 가능합니다.<br/>
                          - 백숙, 치킨, 파전 등 음식 주문 가능합니다.<br/>
                          - 주차는 평상 1개 당 1대 가능합니다.
                        </span>
                    </div>

                    <div className="service-desc2">
                        <h3 style={{marginTop: 0}}>숯불BBQ 이용안내</h3>

                        <h3>◎ 숯불BBQ 대여료안내</h3>
                        <span>
                          - 숯+그릴+석쇠 제공<br/>
                          - 2~4인 20,000원 / 5~8인 30,000원 (숯추가 10,000원 ~)<br/>
                        </span>

                        <h3>◎ 숯불BBQ 안내사항</h3>
                        <span>
                          - 숯불 운영시간은 22시까지입니다.<br/>
                          - 장소는 개별 바베큐장 또는 평상에 준비해드립니다.<br/>
                          - 숯불BBQ 이용시 사전에 예약부탁드립니다.<br/>
                          - 숯불BBQ 이용 1시간전에 말씀해주시면 준비해드립니다.<br/>
                          - 개별장작 또는 화로 절대 사용불가 합니다.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services
